import axios from "axios";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  async getGalerias() {
    return await instance.get("/galerias/get").then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  async getGaleriaId(id) {
    return await instance.get("/galerias/get/"+id).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },

  async saveGaleriaImage(model) {
    console.log(model);
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return await instance.post("/galerias/save", model, config).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  async removeGaleriaImage(item, param) {
    try {
      let response = await instance.delete("/galerias/removeImage/"+param+'/'+item.descricao);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async removeGaleria(item) {
    try {
      let response = await instance.delete("/galerias/"+item._id);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/galeria.js